<div>
  @if (classFlag) {
    <div class="mat-app-background">
      <mat-sidenav-container (click)="clicked()">
        <mat-sidenav #leftSidenav>
          <bas-sidebar-v2 (collap)='receive($event)'></bas-sidebar-v2>
        </mat-sidenav>
        <mat-sidenav-content>
          <bas-header-v2 (collapsed)='received($event)' [sidenav]="leftSidenav"></bas-header-v2>
          <div class="main-content scroll-bar">
            <div class="content">
              <router-outlet></router-outlet>
            </div>
          </div>
          <bas-footer></bas-footer>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </div>
  }

  @if (!classFlag) {
    <div class="mat-app-background">
      <mat-drawer-container class="sidenav-container">
        @if (!classFlag) {
          <mat-drawer #leftsidenav mode="side" opened>
            <bas-sidebar-v2></bas-sidebar-v2>
          </mat-drawer>
        }
        <mat-drawer-content [@onMainContentChange]="onSideNavChange ? 'open': 'close'">
          <bas-header-v2 [sidenav]="leftsidenav"></bas-header-v2>
          <div class="main-content scroll-bar">
            <div class="content">
              <router-outlet></router-outlet>
            </div>
          </div>
          <bas-footer></bas-footer>
        </mat-drawer-content>
      </mat-drawer-container>
    </div>
  }
</div>